import { defineStore } from 'pinia'

export const ScrollOffsetStore = defineStore('offset_store', {
    state: () => {
        return { offset_store: [] }
    },
    actions: {
        get() {
            return this.offset_store
        },
        set(value) {
            this.offset_store = value
        }
    },
})